import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("defs", { key: '0' },
        React.createElement("clipPath", { id: 'transportMarkerClip' },
            React.createElement("path", { id: 'transportMarkerShape', d: 'M12,2L4.5,20.3L12,18l7.5,2.3L12,2z' }))),
    React.createElement("use", { key: '1', xlinkHref: '#transportMarkerShape', fill: 'none', stroke: '#000000' }),
    React.createElement("use", { key: '2', xlinkHref: '#transportMarkerShape', stroke: '#ffffff', clipPath: 'url(#transportMarkerClip)' }),
], 'TransportMarker');
const TransportMarkerIcon = function (props) {
    return (React.createElement(SvgIcon, Object.assign({ xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', sx: {
            'path:nth-of-type(3)': {
                fill: props.htmlColor,
            },
        } }, props)));
};
export default memo(TransportMarkerIcon);
